import React, { useEffect, useState } from "react";
import FrontVideo from "../../components/homevideo";
import ClientExperiences from "../../components/home/client-experiences";
import { API_BASE_URL } from "../../config/config";
import axios from "axios";
import WhatWeOffer from "../../components/CommonSections/WhatWeOffer";
import Advantage from "../../components/CommonSections/Advantage";
import PageLoader from "../../components/home/pageload";
import MetaTag from "../../components/CommonSections/MetaTag";
import ImgEnterpriseConnectivity from "../../assest/images/IshanEnterpriseConnectivity.png";
import { Link } from "react-router-dom";
import SubServiceSchema from "../../components/CommonSections/subServicesSchema";

export default function EnterpriseConnectivity() {

     const [enterpriseConnectivityData, setEnterpriseConnectivityData] = useState(null);
     const [settingResponse, setSettingResponse] = useState(null);

     const handleClick = () => {
          window.scrollTo(0, 0);
     }
     useEffect(() => {
          const requestData = {
               "service_tag": "enterprise_connectivity"
          };

          axios.post(`${API_BASE_URL}/api/enterpriseservices/getEnterpriseServices`, requestData).then((response) => {

               setEnterpriseConnectivityData(response);

               const generalSettingsData = response?.data?.data?.general_settings?.general_settings_data;

               const networkServicesSettingsData = generalSettingsData.find((item) => item.tag === "enterprise_connectivity") || null;
               const networkServicesSettingsResponse = JSON.parse(networkServicesSettingsData?.response || "{}");

               setSettingResponse(networkServicesSettingsResponse);
          }).catch((error) => {
               <PageLoader />
          })
     }, [])

     return (

          <>
               {enterpriseConnectivityData === null ? (
                    <PageLoader />
               ) : (
                    <>
                    <SubServiceSchema title={enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0].title} url='https://ishantechnologies.com/network-services/enterprise-connectivity' parentTitle='Network Services' parentUrl='https://ishantechnologies.com/network-services' />
                    <MetaTag data={enterpriseConnectivityData} pageKey="enterprise_services"/>
                         <div className="page_heading responsive_heading">
                              <div className="container">
                                   <h1>{enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data[0]?.title}</h1>
                                   <p>{enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data[0]?.sub_title}
                                        <span>{enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data[0]?.italic}</span>
                                   </p>
                              </div>
                         </div>
                         <div className={`video hero-banner ${
                              !enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                                                            [0]?.banner_title &&!enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                                                            [0]?.banner_img_desc 
                                   ? 'no-content' 
                                   : ''
                              }`}
                              >
                              <FrontVideo homeData={enterpriseConnectivityData} pageKey="enterprise_services" />
                      
                              <div className="banner-content ">
                                   {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0]?.banner_title && (
                                   <h2 className='home-heading'>
                                        {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0].banner_title}
                                   </h2>
                                   )}

                                   {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0]?.banner_img_desc && (
                                   <p className="para">
                                        {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0].banner_img_desc}
                                   </p>
                                   )}

                                   {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0]?.button_img_name && (
                                   <a href={enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0].button_url}>
                                        <button className="button hero-btn">
                                        {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_banner_data
                              [0]?.button_img_name}
                                        </button>
                                   </a>
                                   )}
                                   </div> 
                         </div>


                         <div className="empowering section-space spin-wrap">
                              <div className="spin-round-wrap">
                                   <div className="spin-round color-navy-blue">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>
                              <div className="container">
                                   <div className="empowering-inner">
                                        <div className="empowering-left">
                                             {<img src={ImgEnterpriseConnectivity} alt="Enterprise Connectivity" height={60} width={60} loading="lazy"/>}
                                        </div>
                                        <div className="empowering-right" dangerouslySetInnerHTML={{ __html: enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_information_data[0]?.description }}>
                                        </div>
                                   </div>
                              </div>
                              <div className="spin-round-wrap">
                                   <div className="spin-round">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>
                         </div>
                         <div className="weoffer-bgdark">
                              <WhatWeOffer title={settingResponse?.what_we_offer} data={enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_offer_data} />
                         </div>

                         <Advantage title={settingResponse?.advantages} data={enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_advantages_data} />


                         <div className="client-experiences section-space">
                              <ClientExperiences homeData={enterpriseConnectivityData} pageKey="enterprise_services" tag="enterprise_connectivity" />
                         </div>

                         <div className="supercharge supercharge-left">
                              <div className="container">
                                   <h2 className="supercharge-heading">{enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.title}</h2>
                                   <div className="supercharge-btns">

                                        {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.button_title_1 &&
                                             <Link to={enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.button_url_1}>
                                                  <button className="getintouch" onClick={handleClick}>{enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.button_title_1?.toUpperCase()}</button>
                                             </Link>
                                        }
                                        {enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.button_title_2 &&
                                             <Link to={enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.button_url_2} target="_blank">
                                                  <button className="getintouch" onClick={handleClick}>{enterpriseConnectivityData?.data?.data?.enterprise_services?.enterprise_services_cta_banner_data[0]?.button_title_2?.toUpperCase()}</button>
                                             </Link>
                                        }
                                   </div>
                              </div>
                         </div>
                    </>
               )}
          </>

     );
}